import { useCallback, useEffect, useRef, useState } from "react";

const COPIED_RESET_DELAY = 1500;

/**
 * Copies text to the clipboard and exposes a transient `isCopied` flag that resets after a delay.
 */
export const useCopyToClipboard = (resetDelay: number = COPIED_RESET_DELAY) => {
	const [isCopied, setIsCopied] = useState(false);
	const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	const copy = useCallback(
		async (value?: string) => {
			if (!value || !navigator.clipboard) {
				return;
			}
			await navigator.clipboard.writeText(value);
			setIsCopied(true);
			clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => setIsCopied(false), resetDelay);
		},
		[resetDelay]
	);

	return { isCopied, copy };
};
